import { TankBatteryBase } from './base/tank-battery-base';

export class TankBattery extends TankBatteryBase { }